import React from 'react'

// Component ----

function EmptyState() {
  return (
    <div className='flex flex-col h-full items-center justify-center px-6'>
      <p className='text-gray-500 text-sm text-center'>
        Sorry, there is nothing to choose from.
      </p>
    </div>
  );
}

export {EmptyState};